import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from '@mui/material/Alert';

interface props {
  open: boolean;
  setOpen: (open: boolean) => void;
  message?: string;
  severity: AlertColor; 
}

const SUCCESS_MESSAGE = 'Dane zostały poprawnie zapisane!';
const ERROR_MESSAGE = 'Podczas zapisu danych wystąpił błąd!';
const INFO_MESSAGE = 'Dane zostały zaktualizowane!';

const GridNotification = (props: props) => {
  const [vertical, setVertical] = useState<'top' | 'bottom'>('top');

  useEffect(() => {
    const updateVerticalPosition = () => {
      if (window.innerWidth < 1246) { 
        setVertical('top');
      } else {
        setVertical('top');
      }
    };

    updateVerticalPosition();
    window.addEventListener('resize', updateVerticalPosition);

    return () => {
      window.removeEventListener('resize', updateVerticalPosition);
    };
  }, []);

  const handleClose = (e?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    props.setOpen(false);
  };

  return (
    <Snackbar
      open={props.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal: 'center' }}
      sx={{
        width: '100%',
        maxWidth: '400px',
        '@media (max-width: 1246px)': {
          maxWidth: '90%',
        },
      }}
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={props.severity}
        sx={{ width: '100%' }}
      >
        {props.message ? props.message : (props.severity === 'error' ? ERROR_MESSAGE : (props.severity === 'info' ? INFO_MESSAGE : SUCCESS_MESSAGE))}
      </Alert>
    </Snackbar>
  );
};

export default GridNotification;